import React from "react";
import "./FeatureSection.css";

const features = [
  {
    icon: "/assets/feature-icon1.svg",
    text: "Sabre's modular, open, cloud-native technology ensures reliability and flexibility at scale.",
  },
  {
    icon: "/assets/feature-icon2.svg",
    text: "Agencies can connect only what they need — keeping operations smooth and customers happy.",
  },
  {
    icon: "/assets/feature-icon3.svg",
    text: "With AI-enabled workflows and enterprise-grade reliability, Sabre delivers tools that grow with your business, not against it.",
  },
];

function FeatureSection() {
  return (
    <section className="about-feature-section section-padding">

  <div className="about-container">

    <div className="row align-items-center">

      <div className="col-lg-6 mb-5 mb-lg-0">

        <div className="about-feature-image-wrapper">

          <img
            src="/assets/feature-image.png"
            alt="Feature"
            className="about-feature-image"
          />

          <div className="about-feature-counter">

            <div className="about-feature-number">
              14
            </div>

            <div className="about-feature-counter-content">

              <h4>
                Countries. One Trusted Partner.
              </h4>

              <p>
                Expanding travel businesses across Africa with
                Sabre-powered technology, local expertise,
                and responsive support.
              </p>

            </div>

          </div>

        </div>

      </div>
     {/* <div className="col-lg-1"></div> */}

      <div className="col-lg-6 padding-60"  style={{ paddingLeft: "60px" }}>

        <h2 className="about-feature-heading">
          Built for Today.
          <span className="title-blue"> Ready </span>
          for Tomorrow.
        </h2>

        <p className="about-feature-desc">
          TNS adds local power — helping African agencies implement,
          integrate, and localize Sabre's solutions for the regional
          market.
        </p>

        <div className="about-feature-list">

          {features.map((item, index) => (

            <div
              className="about-feature-item"
              key={index}
            >

              <div className="about-feature-icon">

                <img
                  src={item.icon}
                  alt=""
                />

              </div>

              <p>{item.text}</p>

            </div>

          ))}

        </div>

      </div>

    </div>

  </div>

</section>
  );
}

export default FeatureSection;